import { apiFetch } from '@m/utils/http';

import type { PaymentDueFollowup, TodoItem } from '@m/types/api/TodoItem';
import type { User } from '@m/types/api/User';

type GetTodosV2Data = {
  expressOnboardingExperimentGroup: string;
  todoItems: TodoItem[];
};

type GetPaymentOverdueTaskData = {
  todoItems: PaymentDueFollowup[];
};

type JoinOptOutData = {
  user: User;
};

type OptOutTaskData = {
  customerTaskId: number;
};

type ConfirmMissedEntryStartVisitData = {
  transactionId?: number;
};

const TodoService = {
  getTodosV2: async () => apiFetch<GetTodosV2Data>('/v2/customer/todo'),

  getPaymentOverdueTask: () => apiFetch<GetPaymentOverdueTaskData>('/customer/payment-due'),

  joinFlowOptOut: () => apiFetch<JoinOptOutData>('/customer/join/opt-out', { method: 'POST' }),

  /**
   * believe this is only used in the missed entry flow. need to confirm with BE what this does
   * @param customerTaskId
   */
  postMissedEntryOptOut: ({ customerTaskId }: { customerTaskId: number }) =>
    apiFetch<OptOutTaskData>(`/customer/task/${customerTaskId}/opt-out`, {
      method: 'POST',
    }),

  postConfirmMissedEntryStartVisit: ({
    missedEntryStartVisitTaskId,
    vehicleId,
  }: {
    missedEntryStartVisitTaskId: number;
    vehicleId: number;
  }) =>
    apiFetch<ConfirmMissedEntryStartVisitData>(
      `/customer/missed-entry-start-visit/${missedEntryStartVisitTaskId}/confirm`,
      {
        method: 'POST',
        body: { vehicleId },
      },
    ),
};

export default TodoService;
